<template>
    <div>
        <v-row>
            <v-col>
                <autocompleteOneForm
                    label="Empresa"
                    :loading="loadingCompanies"
                    :valueInput="values.company_id"
                    :rule="rules.required"
                    :items="serverItems.company"
                    :errorMessages="serverErrors.company_id"
                    @valueChange="
                        (v) => {
                            values.company_id = v;
                            getEmployeeByBusiness(v);
                            delete serverErrors.company_id;
                        }
                    "
                ></autocompleteOneForm>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <autocompleteOneForm
                    label="Colaborador"
                    :loading="loadingEmployees"
                    :valueInput="values.employeeId"
                    :rule="rules.required"
                    :items="serverItems.employees"
                    :errorMessages="serverErrors.employeeId"
                    @valueChange="
                        (v) => {
                            values.employeeId = v;
                            delete serverErrors.employeeId;
                        }
                    "
                ></autocompleteOneForm>
            </v-col>
        </v-row>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    props: ['values', 'serverErrors', 'surveyId'],

    data() {
        return {
            loadingCompanies: false,
            loadingEmployees: false,

            rules: {
                required: [(v) => !!v || 'El campo es requerido'],
            },
            serverItems: {
                company: [],
                employees: [],
            },
        };
    },
    watch: {
        values: function (vv) {
            //console.log(this.values, vv);
        },
    },
    mounted() {
        this.getCompanies();
    },
    methods: {
        getCompanies() {
            this.loadingCompanies = true;
            this.$api.user
                .getUserBusinessSelect()
                .then((resp) => {
                    //console.log(resp, "desde form");
                    this.serverItems.company = resp.data.map((item) => {
                        return { text: item.name, value: item.id };
                    });
                })
                .catch((error) => {
                    console.log(error, 'error desde form areas');
                })
                .finally(() => {
                    this.loadingCompanies = false;
                });
        },
        getEmployeeByBusiness(business = undefined)
        {
            if(business == '' || business == undefined)
                return;
            this.serverItems.employees = [];
            this.values.employeeId = '';
            this.loadingEmployees = true;
            this.$api.questionaries.getPendingEmployeesByCompany(this.surveyId, business)
                .then((resp) => {

                    resp.data.forEach(emp => {
                        if(!emp.has_answers)
                            this.serverItems.employees.push({value:emp.id, text:emp.name});
                    });
                   
                })
                .catch((error) => {
                    console.log(error, "assing form");
                })
                .finally(() =>{
                    this.loadingEmployees = false;
                })
            ;
        },
    },
};
</script>

<style></style>
